import { CircularProgress } from '@mui/material'
import { SpinnerBoxCenter } from './styles'

const SpinnerBoxBlock = () => {
    return (
        <SpinnerBoxCenter>
            <CircularProgress color='primary' />
        </SpinnerBoxCenter>
    )
}


export default SpinnerBoxBlock
